import * as B from '@blueprintjs/core';
import * as I from 'immutable';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import SparkleIcon from 'app/components/Library/Icons/SparkleIcon';
import {ApiOrganization} from 'app/modules/Remote/Organization';
import featureFlags, {useUserInfo} from 'app/utils/featureFlags';
import * as routeUtils from 'app/utils/routeUtils';

import cs from './styles.module.scss';

export const AddPropertiesOptions: React.FunctionComponent<
  React.PropsWithChildren<{
    organization: I.ImmutableOf<ApiOrganization>;
    projectId: string;
  }>
> = ({organization, projectId}) => {
  const navigate = useNavigate();
  const [, profile] = useUserInfo();
  const orgIdPrefix = routeUtils.makeUuidPrefix(organization.get('id'));

  return (
    <div className={cs.selectModeOptions}>
      <B.Button
        minimal
        onClick={() => navigate(`/${orgIdPrefix}/admin/manageProperties/draw/${projectId}`)}
      >
        <div className={cs.selectModeOption}>
          <B.Icon icon="new-drawing" size={32} />
          <h4>Draw on the map</h4>
        </div>
      </B.Button>

      <B.Button
        minimal
        onClick={() => navigate(`/${orgIdPrefix}/admin/manageProperties/upload/${projectId}`)}
      >
        <div className={cs.selectModeOption}>
          <B.Icon icon="cloud-upload" size={32} />
          <h4>Upload from a file</h4>
        </div>
      </B.Button>

      <B.Tooltip content="Select US tax parcels and more" position="bottom-right">
        <B.Button
          minimal
          onClick={() => navigate(`/${orgIdPrefix}/admin/manageProperties/parcel/${projectId}`)}
        >
          <div className={cs.selectModeOption}>
            <B.Icon icon="select" size={32} />
            <h4>{`Select overlay polygons`}</h4>
          </div>
        </B.Button>
      </B.Tooltip>

      {featureFlags.AGENT_ONBOARDING(organization, profile) && (
        <B.Button
          minimal
          onClick={() =>
            navigate(`/${orgIdPrefix}/admin/manageProperties/agentUpload/${projectId}`)
          }
        >
          <div className={cs.selectModeOption}>
            <SparkleIcon size={32} />
            <h4>Create with the agent</h4>
          </div>
        </B.Button>
      )}
    </div>
  );
};
